import axiosInstance from '../axiosInstance';

export const fetchReferenceManifestForBulk = async (manifestId) => {
    if (!manifestId) {
        throw new Error('Debe indicar el código del manifiesto de referencia.');
    }

    const response = await axiosInstance.get(
        `/manifests/manifest-reference-bulk/${manifestId}`
    );

    return response.data;
};

export const createBulkManifestsFromOrders = async (data) => {
    const response = await axiosInstance.post(
        '/manifests/bulk-from-orders',
        data,
        {
            timeout: 60000, // 1 minutos
        }
    );

    return response.data;
};
